import { Controller } from "@hotwired/stimulus";

const panelStyle = `
  position: absolute;
  z-index: 1;
  margin-top: 37px;
  padding: 10px;
  display: none;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 400px;
`.replace(/\s+/, ' ')

const tagStyle = `
  display: inline-block;
  background-color: #f7f7f7;
  padding: 1px 7px;
  border-radius: 5px;
  margin: 0 7px 7px 0;
  cursor: pointer;
  color: #ffffff;
  margin: 0 5px 5px 0;
`.replace(/\s+/, ' ')

const limit = 10;

export default class extends Controller {
  connect() {
    this.colors = {}
    this.types = {}
    this.choices = JSON.parse(this.data.get("source")).map((el) => {
      const [tag_name, color, tag_type] = el
      const name = tag_type ? `${tag_name} (${tag_type})` : tag_name
      this.colors[name] = color;
      return name
    })
    this.selected = this.element.value.split(',').map((el)=>el.trim()).filter((el)=>!!el)
    this.selected = [...new Set(this.selected)]
    this.choices = [...new Set(this.choices)]
    this.can_create = String($(this.element).data('can-create')) == 'true'
    this.model_class = $(this.element).data('model-class')

    this.panel = document.createElement('div')
    this.panel.classList.add('shadow-sm')
    this.panel.style = panelStyle

    this.element.parentNode.insertBefore(this.panel, this.element)
    this.drawTags = this.drawTags.bind(this)

    this.element.autocomplete = 'off'
    this.element.style.cursor = 'pointer'
    this.element.onkeydown = ()=> false
    this.element.onclick = this.togglePanel.bind(this)
    this.element.onfocus = ()=> $(this.element).blur()

    const placeholder = this.can_create ? 'filter or add tags' : 'filter tags'
    this.panel.innerHTML = `
      <span class="btn btn-secondary btn-sm close" style="float: right;">close</span>
      <p style="margin-bottom: 10px;">
        <input type="text" class="form-control" placeholder="${placeholder} tags" style="width: 150px;" />
      </p>
      <div class="tags-data-panel"></div>
    `

    this.panel = $(this.panel)

    this.panel.find('span.close').on('click', this.togglePanel.bind(this))
    let me = this
    let input = this.panel.find('input')
    input.on('keydown', (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
        if (this.can_create) {
          me.toggleTag.bind(me)(e)
          e.target.value = ''
        } else {
          alert(`Adding tags is not allowed on ${this.model_class}.`)
        }
      }
    })
    input.on('keyup', (e) => {
      this.inputValue = e.target.value
      this.drawTags()
    })

    this.drawTags()
  }

  drawTags() {
    const tagsPanel = this.panel.find('.tags-data-panel').empty();

    $('<h6>')
      .css('margin-bottom', '10px')
      .text('Selected')
      .appendTo(tagsPanel);

    for (let el of this.selected) {
      const tag = this.drawTag(el);

      if (tag) {
        tag.appendTo(tagsPanel);
      }
    }

    if (!this.selected[0]) {
      tagsPanel.append('&mdash;')
    }

    $('<h6>')
      .css('margin', '15px 0 10px 0')
      .text('All tags')
      .appendTo(tagsPanel);

    let i = 0;
    let list = $(this.choices).not(this.selected).get();

    const draw = () => {
      let tagsCount = 0;

      while (i < list.length) {
        let el = list[i];
        let tag = this.drawTag(el);

        if (tag) {
          tagsCount++;

          if (tagsCount > limit) {
            break;
          } else {
            tag.appendTo(tagsPanel); 
          }
        }

        i++;
      }

      if (!list[0]) {
        tagsPanel.append('&mdash;')
      }

      if (tagsCount > limit) {
        $('<a>')
          .attr('href', 'javascript:void(0)')
          .text('More')
          .appendTo(tagsPanel)
          .on('click', function() {
            $(this).remove();
            draw();
          })
      }
    }

    draw();
  }

  drawTag(name) {
    let bgColor = this.colors[name] || '#ffffff'
    let style = tagStyle
    let display = this.types[name] ? `${name} (${this.types[name]})` : name
    style += bgColor == '#ffffff' ? 'color: #111; border: 1px solid #ccc;' : 'text-shadow: 0 0 3px #000;'

    if (this.inputValue && !display.includes(this.inputValue)) {
      return;
    } else {
      return $('<span>')
                .addClass('tag')
                .attr('style', `${style}; background-color: ${bgColor};`)
                .attr('data-tag', name)
                .text(display)
                .on('click', this.toggleTag.bind(this));
    }
  }

  toggleTag(e) {
    let name = e.target.value || $(e.target).data('tag') || e.target.innerHTML

    if (this.selected.includes(name)) {
      this.selected = this.selected.filter((el) => el != name)
    } else {
      this.selected.push(name)
      this.selected = this.selected.sort()
    }

    this.element.value = this.selected.join(', ')

    this.drawTags.bind(this)()
  }

  togglePanel() {
    this.panel.toggle()
  }
}
